import { PURCHASE_CREDITS, PURCHASE_CREDITS_SUCCESS, PURCHASE_CREDITS_FAILURE } from "../actions/user"
import { EVENT_CREATED, EVENT_ADDED_ROOM, EVENT_REMOVED_ROOM } from '../actions/event'

const initialState = {
  email: "",
  id: "",
  profile: {},
  transactions: [],
  purchasing: false,
  total: 0
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case "USER_NEW":
      return Object.assign({}, state, {
        email: action.payload.user.email,
        id: action.payload.user.id
      })
    case "USER_LOGIN":
      return Object.assign({}, state, {
        email: action.payload.user.email,
        id: action.payload.user.id
      })
    case "USER_UPDATED":
      return Object.assign({}, state, {
        profile: action.payload.profile
      })
    case EVENT_CREATED:
    case EVENT_ADDED_ROOM:
    case EVENT_REMOVED_ROOM:
      return Object.assign({}, state, {
        profile: {
          ...state.profile,
          credits: action.payload.credits
        }
      })
    case "USER_PROFILE":
      return Object.assign({}, state, {
        email: action.payload.data.user.email,
        id: action.payload.data.user.id,
        profile: action.payload.data.user,
        transactions: action.payload.data.transactions,
        total: action.payload.data.total
      })
    case "USER_STRIPE":
      return Object.assign({}, state, {
        profile: action.payload.profile
      })
    case "USER_LOGOUT":
      return Object.assign({}, state, initialState)
    case PURCHASE_CREDITS: {
      return Object.assign({}, state, { purchasing: true })
    }
    case PURCHASE_CREDITS_SUCCESS: {
      return Object.assign({}, state, {
        purchasing: false,
        profile: {
          ...state.profile,
          credits: action.payload.credits
        }
      })
    }
    case PURCHASE_CREDITS_FAILURE: {
      return Object.assign({}, state, { purchasing: action.payload })
    }
    default:
      return state
  }
}
